import { Row, Col, Cell } from "./components/Containers";
import { HorizontalDivider, VerticalDivider } from "./components/Dividers";

const Flex = { Row, Col, Cell, HorizontalDivider, VerticalDivider };

export default Flex;
